<template lang="pug">
	.fondoModal
		div
			div
				div.card
					.card-header
						| Gráficos
						button(type="button" class="close" data-dismiss="modal" aria-label="Close" @click="cerrar") &times
					.mt-2
						.nav.nav-tabs
							li.nav-item(style="cursor:pointer" v-if="graficoReal")
								a(:class="(seccion === 'real') ? 'active' : ''" class="nav-link" @click="setSeccion('real')") Real
							li(class="nav-item" style="cursor:pointer" v-if="graficoAcumulado")
								a(:class="(seccion === 'acumulado') ? 'active' : ''" class="nav-link" @click="setSeccion('acumulado')") Acumulado
							li(class="nav-item" style="cursor:pointer" v-if="graficoTotal")
								a(:class="(seccion === 'total') ? 'active' : ''" class="nav-link" @click="setSeccion('total')") Total
							li(class="nav-item" style="cursor:pointer" v-if="listadoContratos")
								a(:class="(seccion === 'contratos') ? 'active' : ''" class="nav-link" @click="setSeccion('contratos')") Contratos
					div
						representar(v-if="seccion === 'real'" :datos="graficoReal")
						representar(v-if="seccion === 'acumulado'" :datos="graficoAcumulado")
						representar(v-if="seccion === 'total'" :datos="graficoTotal")
					div
						div(v-if="seccion === 'real'")
							h4 Real
							representar(v-if="datosReal" :datos="datosReal")
						div(v-if="seccion === 'acumulado'")
							h4 Real acumulado
							representar(v-if="datosRealAcumulado" :datos="datosRealAcumulado")
						div(v-if="seccion === 'total'")
							h4 Total anual
							representar(v-if="datosRealTotal" :datos="datosRealTotal")
						div.table-responsive.text-left(v-if="seccion === 'contratos'")
							download-excel.m-2(
								class   = "btn btn-warning btn-sm"
								:data   = "json_data"
								:fields = "json_fields"
								:meta   = "json_meta"
								name	= "informe.xls"
							)
								span.fa.fa-download.mr-2
								| XLS
							table.table.table-striped.table-condensed
								thead
									tr
										th Mes
										th Soporte
										th Cliente
										th Agente
										th Contrato
										th.text-right Importe
								tbody
									tr(v-for="linea in listadoContratos" :key="linea.contratoId + '' + linea.fecha.getMonth() + '' + linea.soporteNombre + '' + linea.facturacionId")
										td {{meses[linea.fecha.getMonth()]}}, {{linea.fecha.getFullYear()}}
										td {{linea.soporteNombre}}
										td {{linea.clienteNombre}}
										td {{linea.agenteNombre}}
										td.contrato(@click="ContratoID = linea.contratoId") {{linea.contratoTitulo}}
										td.text-right {{linea.importe | currency }}
								tbody
									tr.bg-dark.text-white
										td(colspan="5" class="text-right")
											b Total
										td.text-right {{sumaFacturacion | currency}}
		modal(:max-width="1600", v-if='ContratoID', :top="10")
			.card.text-left
				.card-header
					button.close(@click="ContratoID=null") &times;
				.card-body
					VisorContrato(:ContratoID="ContratoID")
</template>

<script>
import Representacion from './representarDatos'
import VisorContrato from '../../../../mis-contratos/vue/components/visor-contrato/visor-contrato.vue'
export default {
	props: ['datos'],
	components: {
		'representar': Representacion,
		VisorContrato: VisorContrato
	},

	data: function () {
		return {
			meses: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
			labels: [],
			graficoReal: null,
			graficoTotal: null,
			graficoAcumulado: null,
			listadoContratos: null,
			seccion: 'real',
			ContratoID: null
		}
	},

	created () {
		console.time()
		console.info('Comenzamos')
		this.graficoReal = this.getTotal()
		this.graficoTotal = this.getTotalFacturacionAnos()
		this.graficoAcumulado = this.getAcumulados()
		this.listadoContratos = this.getListadoContratos()
		console.log('Terminamos')
		console.timeEnd()
	},

	computed: {
		json_data () {
			if (!this.listadoContratos) {
				return []
			}

			return this.listadoContratos.reduce((acum, contrato) => {
				const item = {
					mes: this.meses[contrato.fecha.getMonth()] + ', ' + contrato.fecha.getFullYear(),
					soporte: contrato.soporteNombre,
					cliente: contrato.clienteNombre,
					agente: contrato.agenteNombre,
					contrato: contrato.contratoTitulo,
					importe: this.$options.filters.currency(contrato.importe)
				}
				acum.push(item)
				return acum
			}, [])
		},
		json_fields () {
			if (!this.listadoContratos) {
				return {}
			}
			const f = {}

			f.mes = 'String'
			f.soporte = 'String'
			f.cliente = 'String'
			f.agente = 'String'
			f.contrato = 'String'
			f.importe = 'String'
			return f
		},
		json_meta () {
			return [
				[{
					'key': 'charset',
					'value': 'utf-8'
				}]
			]
		},
		mesMenor () {
			let actual = this.datos.fechas.fecha_ini
			let mes = actual.getMonth()
			while (actual.getTime() <= this.datos.fechas.fecha_fin.getTime()) {
				const m = actual.getMonth()
				mes = (mes > m) ? m : mes
				const ano = (m === 11) ? actual.getFullYear() + 1 : actual.getFullYear()
				const sig = (m === 11) ? 0 : m + 1

				actual = new Date(ano, sig, 1, 0, 0, 0, 0)
			}

			return mes
		},

		mesMayor () {
			let actual = this.datos.fechas.fecha_ini
			let mes = actual.getMonth()
			while (actual.getTime() <= this.datos.fechas.fecha_fin.getTime()) {
				const m = actual.getMonth()
				mes = (mes < m) ? m : mes
				const ano = (m === 11) ? actual.getFullYear() + 1 : actual.getFullYear()
				const sig = (m === 11) ? 0 : m + 1

				actual = new Date(ano, sig, 1, 0, 0, 0, 0)
			}

			return mes
		},

		sumaFacturacion () {
			let importe = 0

			for (let i = 0; i < this.listadoContratos.length; i++) {
				importe += parseFloat(this.listadoContratos[i].importe)
			}

			return importe
		}
	},

	methods: {
		setSeccion (seccion) {
			this.seccion = seccion
		},
		creaDataSets () {
			const d = []
			const labels = []
			let actual = this.datos.fechas.fecha_ini

			do {
				let ano = actual.getFullYear()
				let encontrado = false
				for (let i = 0; i < d.length; i++) {
					if (d[i].label === ano.toString()) {
						encontrado = true
					}
				}

				if (!encontrado) {
					const color = this.getRandomColor()
					d.push({
						label: ano.toString(),
						data: [],
						backgroundColor: color,
						borderColor: color,
						fill: false
					})
				}
				const mes = actual.getMonth()
				ano = (mes === 11) ? actual.getFullYear() + 1 : actual.getFullYear()
				const sig = (mes === 11) ? 0 : mes + 1

				actual = new Date(ano, sig, 1, 0, 0, 0, 0)
			} while (actual.getTime() <= this.datos.fechas.fecha_fin.getTime())

			// ahora rellenamos todos los datasets con ceros en todos sus meses
			for (let i = 0; i < d.length; i++) {
				for (let m = this.mesMenor; m <= this.mesMayor; m++) {
					const clave = this.meses[m]

					if (labels.indexOf(clave) < 0) {
						labels.push(clave)
					}

					d[i].data[m] = 0
				}
			}

			return {
				labels: labels,
				data: d
			}
		},
		getTotal () {
			// Evolución del real total
			const totales = {}

			if (this.datos.totales && this.datos.totales.TOTAL) {
				const info = this.creaDataSets()
				const totalReal = {
					titulo: 'Evolución Real',
					datos: {},
					labels: info.labels,
					datasets: info.data,
					tipo: 'barras'
				}

				for (let i = 0; i < this.datos.totales.TOTAL.datos.campos.real.facturacion.length; i++) {
					const d = this.datos.totales.TOTAL.datos.campos.real.facturacion[i]
					const fecha = new Date(parseInt(d.fecha) * 1000)
					const ano = fecha.getFullYear()
					const mes = fecha.getMonth()
					const offset = mes - this.mesMenor

					for (let f = 0; f < totalReal.datasets.length; f++) {
						if (totalReal.datasets[f].label === ano.toString()) {
							totalReal.datasets[f].data[offset] += parseFloat(d.importe)
							totales[ano] = (totales[ano]) ? totales[ano] + parseFloat(d.importe) : parseFloat(d.importe)
						}
					}
				}

				return totalReal
			} else {
				return null
			}
		},
		getCoberturas () {
			// Obtenemos las coberturas por soportes

		},

		getAcumulados () {
			let totales = null

			try {
				totales = this.datos.totales.TOTAL.datos.campos.real.facturacion
			} catch (e) {
				return null
			}

			const info = this.creaDataSets()
			const totalAcum = {
				titulo: 'Evolución acumulado',
				datos: {},
				labels: info.labels,
				datasets: info.data,
				tipo: 'lineas'
			}

			for (let i = 0; i < totales.length; i++) {
				const fecha = new Date(parseInt(totales[i].fecha) * 1000)
				const ano = fecha.getFullYear().toString()
				const mes = fecha.getMonth()

				let m = mes

				for (let a = 0; a < totalAcum.datasets.length; a++) {
					if (totalAcum.datasets[a].label === ano) {
						while (m <= 11) {
							totalAcum.datasets[a].data[m] = totalAcum.datasets[a].data[m] + parseFloat(totales[i].importe)
							m++
						}
					}
				}
			}

			return totalAcum
		},

		getTotalFacturacionAnos () {
			if (this.datos.fechas.fecha_ini.getFullYear() !== this.datos.fechas.fecha_fin.getFullYear()) {
				// Sumamos los importes de cada ano
				const datos = {}
				let arr = null

				try {
					arr = this.datos.totales.TOTAL.datos.campos.real.facturacion
				} catch (e) {
					console.error(e)
					return null
				}
				for (let i = 0; i < arr.length; i++) {
					const ano = new Date(parseInt(arr[i].fecha) * 1000).getFullYear().toString()
					datos[ano] = (!datos[ano]) ? parseFloat(arr[i].importe) : datos[ano] + parseFloat(arr[i].importe)
				}

				const objeto = {
					titulo: 'Total años',
					labels: Object.keys(datos),
					datasets: [
						{
							data: Object.values(datos),
							label: 'Total REAL'
						}
					],
					tipo: 'barras'
				}

				console.log(objeto)

				return objeto
			} else {
				return null
			}
		},
		getRandomColor () {
			var letters = '0123456789ABCDEF'
			var color = '#'
			for (var i = 0; i < 6; i++) {
				color += letters[Math.floor(Math.random() * 16)]
			}
			return color
		},
		getListadoContratos () {
			const arr = []
			let datos = null
			try {
				datos = this.datos.totales.TOTAL.datos.campos.real.facturacion
			} catch (e) {
				return null
			}

			for (let i = 0; i < datos.length; i++) {
				const nuevo = _.clone(datos[i])
				nuevo.fecha = new Date(parseInt(nuevo.fecha) * 1000)
				arr.push(nuevo)
			}

			return arr
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>

<style scoped>
.contrato {
	cursor: pointer;
}
.contrato:hover {
	color: darkblue;
	font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/modulos/consultas-facturacion/vue/components/porAgente/graficosTotales.vue